import { useState } from 'react';
import Button from '@mui/material/Button';
import DatabaseModalForm from './DatabaseModalForm';

interface UpdateDatabaseProps {
  styleOverrides?: React.CSSProperties;
  disabled: boolean;
}

export default function UpdateDatabase(
  {
    styleOverrides,
    disabled,
  }: UpdateDatabaseProps
) {
  // show modal
  const [showDatabaseModal, setShowDatabaseModal] = useState(false);

  const handleModalClick = () => {
    // show modal to update database
    setShowDatabaseModal(true);
  };

  return (
    <>
      <Button
        variant="contained"
        color="success"
        style={styleOverrides}
        disabled={disabled}
        onClick={handleModalClick}
      >
        Update Database
      </Button>
      {/* Modal for updating database */}
      <DatabaseModalForm
        showDatabaseModal={showDatabaseModal}
        setShowDatabaseModal={setShowDatabaseModal}
      />
    </>
  );
};
